import React, { useEffect, useState } from "react";
import { Avatar } from "@mui/material";

export type MiContenidoEntityAvatarProps = {
  name: string;
  src?: string | null;
  size?: number;
  alt?: string;
  /** Forwarded so MUI Chip can apply `.MuiChip-avatar` inset styles. */
  className?: string;
};

function fontSizeForAvatar(size: number): string {
  if (size <= 20) return `${Math.max(10, Math.round(size * 0.55))}px`;
  if (size <= 32) return "0.75rem";
  if (size <= 72) return "1rem";
  return "2.25rem";
}

/**
 * Shared program/brand avatar for mi-contenido.
 * Matches Rendimiento de Programas: rounded, grey.900, single first letter.
 */
export const MiContenidoEntityAvatar: React.FC<MiContenidoEntityAvatarProps> = ({
  name,
  src,
  size = 28,
  alt,
  className,
}) => {
  const trimmed = src?.trim() ?? "";
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [trimmed]);

  const showImage = Boolean(trimmed) && !failed;
  const letter = name.charAt(0).toUpperCase() || "?";

  return (
    <Avatar
      className={className}
      src={showImage ? trimmed : undefined}
      alt={alt ?? name}
      variant="rounded"
      imgProps={{
        onError: () => setFailed(true),
      }}
      sx={{
        width: size,
        height: size,
        flexShrink: 0,
        bgcolor: "grey.900",
        ...(showImage
          ? {
              "& .MuiAvatar-img": {
                objectFit: "cover",
              },
            }
          : {
              color: "grey.50",
              fontSize: fontSizeForAvatar(size),
              fontWeight: 700,
            }),
      }}
    >
      {!showImage ? letter : null}
    </Avatar>
  );
};
